import { ProductTokens } from '../types'
import { colors, PerthNowPalette } from './colors'

export const perthnow: ProductTokens<PerthNowPalette> = {
    colors,
}

export type PNThemeOverride =
    | 'commonwealth-games'
    | 'video-carousel'
    | 'lets-go-freo'

export * from './colors-ngn'
export * from './metrics'
